import React from 'react'
import { ActionIconButton } from '../ActionIconButton/ActionIconButton'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

interface Props {
  onClick?: () => void
}

export const EditIconButton: React.FC<Props> = ({ onClick }) => {
  return (
    <ActionIconButton onClick={onClick}>
      <EditOutlinedIcon />
    </ActionIconButton>
  )
}
